import {BaseContainerModel} from '../base-container.model';
import { bl_inv_pdg_element_import_file_hdr_RowClass} from '../../dbschema/bl_inv_pdg_element_import_file_hdr.model';

export class InventoryPdgElementImportFileHdr extends BaseContainerModel {
    bl_inv_pdg_element_import_file_hdr: bl_inv_pdg_element_import_file_hdr_RowClass = new bl_inv_pdg_element_import_file_hdr_RowClass();
}
